




































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import FileOpen from "@/commonComponents/fileOpen/fileOpen.vue";
// import SelectPattern from "./selectPattern/selectPattern.vue";
// import SelectLine from "./selectLine/selectLine.vue";
import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";

import * as def from "@/definitions";
// TODO document2
import { Document } from "@/model/document2/document";
import { ColorConstruct } from "@/utilityModels/colorConstruct";
import { UserConfig } from '@/model/userConfig/userConfig';

//ズームバー用のモジュール
import { UndoRedoManager } from "@/utilityModels/undoRedoManager";

// ボタン
import RadioOn from "./resources/radioOn.vue";
import RadioOff from "./resources/radioOff.vue";
import CheckOn from "./resources/checkOn.vue";
import PrintSwitching from "./resources/printSwitching.vue";
import ZoomMinusButton from "./resources/zoomMinusButton.vue";
import ZoomPlusButton from "./resources/zoomPlusButton.vue";
import ZoomValue from "./resources/zoomValue.vue";
import AutomaticMode from "./resources/automaticMode.vue";
import Automatic from "./resources/automatic.vue";


import { ResourceHelper } from "@/helper/resourceHelper"
import RangeSlider from '@/components/VRangeSliderZoom.vue';

@Component({
    components: {
        RangeSlider,
        ValueEdit,
        RadioOn,
        RadioOff,
        CheckOn,
        PrintSwitching,
        ZoomMinusButton,
        ZoomPlusButton,
        ZoomValue,
        AutomaticMode,
        Automatic,
        ColorPicker
    }
})
export default class TopController extends Vue {
    @Prop() private document!: Document;
    @Prop() private paperNumber!: number; // 部数
    @Prop() private printStartPage!: number;
    @Prop() private printEndPage!: number;
    @Prop() private maxPage! : number;
    @Prop() private printRate!: number;
    @Prop() private borderColor!: ColorConstruct;
    @Prop() private zoomScale!: number;
    @Prop() private isAutoZoom!: boolean;
    @Prop() private isBorderColorPickerVisible!: boolean;

    private get userConfig() : UserConfig
    {
        return this.$store.getters.userConfig;
    }

    private get printVerticalDirection()
    {
        return this.document.isReverseSurface ? this.userConfig.printVerticalDirectionReverse : this.userConfig.printVerticalDirection;
    }
    private get printHorizontalDirection()
    {
        return this.document.isReverseSurface ? this.userConfig.printHorizontalDirectionReverse : this.userConfig.printHorizontalDirection;
    }

    private get verticalPosition()
    {
        return this.document.isReverseSurface ? this.userConfig.printVerticalPositionReverse : this.userConfig.printVerticalPosition;
    }
    private get horizontalPosition()
    {
        return this.document.isReverseSurface ? this.userConfig.printHorizontalPositionReverse : this.userConfig.printHorizontalPosition;
    }

    private static readonly ZOOM_SCALE_MIN = 25;
    private static readonly ZOOM_SCALE_MAX = 1000;
    private static readonly ZOOM_SCALE_DELTA = 25;

    // 開始ページ : 最大
    private get maxStartPage()
    {
        return this.maxPage;
    }

    // 終了ページ : 最大
    private get maxEndPage()
    {
        return this.maxPage;
    }

    // アンドゥリドゥ管理クラス取得
    private get undoRedoManager(): UndoRedoManager {
        return this.document.undoRedoManager;
    }

    // UndoRedoの表示制御
    private get canUndo(): boolean {
        return this.document.undoRedoManager.canUndo;
    }
    private get canRedo(): boolean {
        return this.document.undoRedoManager.canRedo;
      }

    // 表裏表示制御
    private get isDisplayBack()
    {
        return this.document.isReverseSurface;
    }

    private get isPrintDoubleSides()
    {
        // 両面ない場合はfalse
        if(!this.document.hasReverseSurface) { return false; }
        return this.userConfig.isPrintDoubleSides;
    }

    // 両面の有無を取得
    private get hasReverseSurface()
    {
        return this.document.hasReverseSurface;
    }

    private get fontColor(){
        var style = { color : "#C6C6C6" };
        if(this.hasReverseSurface){ style.color = "#063116" }
        return style;
    }

    // 枠の色
    private get borderColorStyle()
    {
        return { backgroundColor: this.borderColor.hex };
    }

    // スライダー
    private get zoomScaleSliderValue() {
        return this.zoomScale;
    }
    private set zoomScaleSliderValue(zoomScaleSliderValue) {
        this.onDoCommand("changeZoomScale", {
            scale: zoomScaleSliderValue,
            isAutoZoomOff: true
        });
    }

    private onDoCommand(command: string, paramater: any) {
        this.$emit("doCommand", command, paramater);
    }

    // 表面
    private onClickDisplaySurface()
    {
        this.onDoCommand("changeSurface", { isReverse: false });
    }

    // 裏面
    private onClickDisplayBack()
    {
        this.onDoCommand("changeSurface", { isReverse: true });
    }

    // 両面
    private onClickPrintDoubleSides()
    {
        this.onDoCommand("printDoubleSides", null);
    }

    // 反転印刷切り替え
    private get isPrintFlip()
    {
        return this.userConfig.isPrintFlip;
    }
    private onClickPrintFlip()
    {
        this.onDoCommand("setPrintFlip", { isFlip: !this.isPrintFlip });
    }

    // 枠あり印刷切り替え
    private get isBorderVisible()
    {
        return this.userConfig.isPrintBorder;
    }
    private onClickPrintBorder()
    {
        this.onDoCommand("setPrintBorderVisible", {
            isVisible: !this.isBorderVisible
        });
    }

    // 印刷位置
    private changePrintVerticalDirection(direction : string)
    {
        this.onDoCommand("changePrintVerticalDirection", { direction : direction, isReverse : this.document.isReverseSurface });
    }

    private changePrintHorizontalDirection(direction : string)
    {
        this.onDoCommand("changePrintHorizontalDirection", { direction : direction, isReverse : this.document.isReverseSurface });
    }

    // 枠の色
    private onClickBorderColor() {
        var button = this.$refs.borderColorButton as Element;
        var bounds = button.getBoundingClientRect();
        this.onDoCommand("setVisibleBorderColorPicker", {
            left: bounds.left,
            top: bounds.bottom
        });
    }

    // 印刷可能切り替え
    private get canChangePrintable()
    {
        // 差し込み印刷では無効
        return !this.document.useInsertion;
    }

    private onClickChangePrintable()
    {
        this.onDoCommand("changePrintable", null);
    }

    // エディットの値変更
    private setValue(value, tag) {
        if (tag == "pageNumber") {
            // ページ数
            this.onDoCommand("setPaperNumber", { paperNumber: value });
        } else if (tag == "printStartPage") {
            // 印刷開始ページ
            if (value > this.printEndPage) {
                // 開始ページが終了ページを上回る場合は、最終ページを一緒に変更
                this.onDoCommand("setPrintEndPage", { page: value });
            }
            this.onDoCommand("setPrintStartPage", { page: value });
        } else if (tag == "printEndPage") {
            // 印刷終了ページ
            if (value < this.printStartPage) {
                // 終了ページが開始ページを下回る場合は、開始ページを一緒に変更
                this.onDoCommand("setPrintStartPage", { page: value });
            }
            this.onDoCommand("setPrintEndPage", { page: value });
        } else if (tag == "verticalPosition") {
            // 位置調整 : 縦
            this.onDoCommand("setVerticalPosition", { position: value, isReverse : this.document.isReverseSurface });
        } else if (tag == "horizontalPosition") {
            // 位置調整 : 横
            this.onDoCommand("setHorizontalPosition", { position: value, isReverse : this.document.isReverseSurface });
        } else if (tag == "printRate") {
            // 印刷倍率
            this.onDoCommand("setPrintRate", { rate: value });
        }
    }

    // 縦一列コピー
    onClickCopyVerticalButton() {
        this.onDoCommand("copyVertical", null);
    }

    // 横一列コピー
    onClickCopyHorizontalButton() {
        this.onDoCommand("copyHorizontal", null);
    }

    // 全面コピー
    onClickCopyAllButton() {
        this.onDoCommand("copyAll", null);
    }

    // ページ追加
    onClickPageAddButton() {
        this.onDoCommand("addPage", null);
    }

    // ページ削除
    onClickPageDeleteButton() {
        this.onDoCommand("deletePage", null);
    }

    // ズームバー
    private decreaseZoomScale() {
        // 今のzoomScaleより小さく適切な値を求める
        var newValue = TopController.ZOOM_SCALE_MAX;
        while (newValue >= TopController.ZOOM_SCALE_MIN) {
            if (newValue < this.zoomScale) {
                break;
            }
            newValue -= TopController.ZOOM_SCALE_DELTA;
        }
        if (
            this.zoomScale != newValue &&
            newValue >= TopController.ZOOM_SCALE_MIN
        ) {
            this.onDoCommand("changeZoomScale", {
                scale: newValue,
                isAutoZoomOff: true
            });
        }
    }

    private increaseZoomScale() {
        // 今のzoomScaleより大きく適切な値を求める
        var newValue = TopController.ZOOM_SCALE_MIN;
        while (newValue <= TopController.ZOOM_SCALE_MAX) {
            if (newValue > this.zoomScale) {
                break;
            }
            newValue += TopController.ZOOM_SCALE_DELTA;
        }
        if (
            this.zoomScale != newValue &&
            newValue <= TopController.ZOOM_SCALE_MAX
        ) {
            this.onDoCommand("changeZoomScale", {
                scale: newValue,
                isAutoZoomOff: true
            });
        }
    }

    private changeAutoZoom() {
        this.onDoCommand("changeAutoZoom", { isAutoZoom: !this.isAutoZoom });
    }

    //ズームバーの吹き出し
    speechBaloon = false;

    private get zoomSpeechBalloon() {
        let range = (1000 - this.zoomScale) / 475 + "%";
        let distance = "calc(" + this.zoomScale / 10 + "% - 22.5% - " + range + ")";
        var style = {
            position: "absolute",
            left: distance,
            top: "-70%",
            width: "45%",
            height: "70%",
            display: "flex",
            "align-items": "center",
            "justify-content": "center"
        };
        return style;
    }

    progress = 0;
    startPosition = 0;
    scrollWidth = 0;
    private scrollToLeft() {
        var topController = this.$refs["top-controller"] as HTMLElement;
        this.startPosition = topController.scrollLeft;
        this.progress = 0;
        this.scrollWidth =
        topController.clientWidth < 820
            ? -450
            : -(topController.scrollWidth - topController.offsetWidth);
        requestAnimationFrame(this.scrollMove);
    }

    private scrollToRight() {
        var topController = this.$refs["top-controller"] as HTMLElement;
        this.startPosition = topController.scrollLeft;
        this.progress = 0;
        this.scrollWidth =
        topController.clientWidth < 820
            ? 450
            : topController.scrollWidth - topController.offsetWidth;
        requestAnimationFrame(this.scrollMove);
    }

    scrollMove() {
        this.progress++;
        let topController = this.$refs["top-controller"];
        let position =
        this.startPosition + Math.sign(this.scrollWidth) * this.progress * 10;
        (<HTMLElement>topController).scrollTo(position, 0);

        if (
            (position < this.startPosition + this.scrollWidth &&
            this.scrollWidth > 0) ||
            (position > this.startPosition + this.scrollWidth && this.scrollWidth < 0)
        ) {
            requestAnimationFrame(this.scrollMove);
        }
    }

    mounted() {
        window.addEventListener('resize', this.onResize);
        var topController = this.$refs["top-controller"] as HTMLElement;
        if (topController != null) {
            topController.onscroll = this.onScroll;
        }
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize() {
        // カラーピッカー強制非表示
        this.onDoCommand("closeBorderColorPicker", null);
    }

    onScroll() {
        // カラーピッカー強制非表示
        this.onDoCommand("closeBorderColorPicker", null);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigDarkColor(){
        return this.$store.getters.userConfigColors.darkButtonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            borderBottom : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get canUseRadioButtonColor(){
        return "#C6C6C6";
    }

    onCloseColorPicker(){
        this.$emit("onCloseColorPicker")
    }

    private onChangingColor(color) {
        this.$emit("onChangingColor" , color)
    }

    // 色変更完了
    private onChangedColor(color) {
        this.$emit("onChangedColor" , color)
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
}
